import { render, staticRenderFns } from "./onDrawerOpened-editor.vue?vue&type=template&id=166f8a88&scoped=true&"
import script from "./onDrawerOpened-editor.vue?vue&type=script&lang=js&"
export * from "./onDrawerOpened-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f8a88",
  null
  
)

export default component.exports